export default "__VITE_ASSET__CVsDCsis__"